import React from "react";
import { Heading } from "web/react/emo/heading";
import * as styles from "./order-history.css";

export function OrderHistory(): React.ReactElement {
    return (
        <div className={styles.content}>
            <Heading as="h2" textStyle="hero" className={styles.heading}>
                {"My Orders"}
            </Heading>

            <section style={{ border: "1px solid black", marginTop: "2rem" }}>
                {"Order History is coming soon!"}
            </section>
        </div>
    );
}
